// extracted by mini-css-extract-plugin
module.exports = {"button":"GlobalSearch_button__Mx9DX","content":"GlobalSearch_content__3MloF"};